<template>
  <div class="loader-container text-center">
    <div class="icon">
      <div class="sk-wave">
        <div class="sk-rect sk-rect1"></div>
        <div class="sk-rect sk-rect2"></div>
        <div class="sk-rect sk-rect3"></div>
        <div class="sk-rect sk-rect4"></div>
        <div class="sk-rect sk-rect5"></div>
      </div>
    </div>
    <div class="title">{{ $t(title || 'Common.loading') }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: [String, Object],
      default: 'Common.loading'
    },
  },
}
</script>
<style scoped>
.loader-container {
  min-height: 150px;
  display: block;
  opacity: .6;
}
</style>
